import { create } from 'zustand';

const useUrlState = create((set) => ({
    url: '/',
    seturl: (newurl) => set(() => ({ url: newurl })),
}));

export default useUrlState;